import { render, staticRenderFns } from "./ratingsAndReviewCount.vue?vue&type=template&id=51fd30d2&"
import script from "./ratingsAndReviewCount.vue?vue&type=script&lang=js&"
export * from "./ratingsAndReviewCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\scratch\\runner\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('51fd30d2', component.options)
    } else {
      api.reload('51fd30d2', component.options)
    }
    module.hot.accept("./ratingsAndReviewCount.vue?vue&type=template&id=51fd30d2&", function () {
      api.rerender('51fd30d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/SearchNx/Scripts/ListTemplates/Components/ratingsAndReviewCount.vue"
export default component.exports